import React from 'react'
import PropTypes from 'prop-types'

function RatingsRiskEquityStyleBox({ mStarEquityBox }) {
  return (
    <div className="u-sizeFit" id="morningstar-equity-style-box">
      <div className="u-sm-paddingLeft3gu u-sm-paddingTop3gu">
        <h4 className="u-marginBottom3gu">Equity Style Box</h4>
        <div className="Rubric u-sm-marginAuto">
          {renderEquityBoxLine(mStarEquityBox, '1', 'large', 'value')}
          {renderEquityBoxLine(mStarEquityBox, '2', 'large', 'blend')}
          {renderEquityBoxLine(mStarEquityBox, '3', 'large', 'growth')}
          <div className="Rubric-label Rubric-label--Y">Large</div>
          {renderEquityBoxLine(mStarEquityBox, '4', 'medium', 'value')}
          {renderEquityBoxLine(mStarEquityBox, '5', 'medium', 'blend')}
          {renderEquityBoxLine(mStarEquityBox, '6', 'medium', 'growth')}
          <div className="Rubric-label Rubric-label--Y">Medium</div>
          {renderEquityBoxLine(mStarEquityBox, '7', 'small', 'value')}
          {renderEquityBoxLine(mStarEquityBox, '8', 'small', 'blend')}
          {renderEquityBoxLine(mStarEquityBox, '9', 'small', 'growth')}
          <div className="Rubric-label Rubric-label--Y">Small</div>
          <div className="Rubric-label Rubric-label--X">Value</div>
          <div className="Rubric-label Rubric-label--X">Blend</div>
          <div className="Rubric-label Rubric-label--X">Growth</div>
        </div>
      </div>
    </div>
  )
}

function renderEquityBoxLine(mStarEquityBox, dataBoxValue, size, type) {
  return (
    <div
      className={`Rubric-item${
        mStarEquityBox === dataBoxValue ? ' is-selected' : ''
      }`}
      value={dataBoxValue}
      data-size={size}
      data-type={type}
    ></div>
  )
}

RatingsRiskEquityStyleBox.propTypes = {
  mStarEquityBox: PropTypes.string,
}

export default RatingsRiskEquityStyleBox
